export default "__VITE_ASSET__BMguH2nK__"